import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { Star } from 'lucide-react';

function Menu() {
  // Menu items data with correct image paths from your project
  const menuItems = [
    {
      id: 1,
      name: "Pilau Rice",
      price: "Ksh 200",
      rating: 5,
      reviews: 50,
      description: "Feeds 2-3",
      image: "/image/Food 1.png"
    },
    {
      id: 2,
      name: "Beef Kebab",
      price: "Ksh 200",
      rating: 5,
      reviews: 50,
      description: "Feeds 2-3",
      image: "/image/Food 2.png"
    },
    {
      id: 3,
      name: "Chicken Biryani",
      price: "Ksh 250",
      rating: 5,
      reviews: 45,
      description: "Feeds 2-3",
      image: "/image/Food 3.png"
    },
    {
      id: 4,
      name: "Beef Samosa",
      price: "Ksh 150",
      rating: 5,
      reviews: 60,
      description: "Feeds 3-4",
      image: "/image/Food 4.png"
    },
    {
      id: 5,
      name: "Chapati",
      price: "Ksh 100",
      rating: 5,
      reviews: 55,
      description: "Feeds 2-3",
      image: "/image/Food 5.png"
    },
    {
      id: 6,
      name: "Special Rice",
      price: "Ksh 220",
      rating: 5,
      reviews: 48,
      description: "Feeds 2-3",
      image: "/image/Food 6.png"
    },
  ];

  // Splide options for auto-playing carousel with loop
  const splideOptions = {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '2rem',
    padding: '0px',
    pagination: false,
    arrows: false,
    drag: true,
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,
    speed: 600,
    breakpoints: {
      1024: {
        perPage: 3,
        gap: '1.5rem',
      },
      768: {
        perPage: 2,
        gap: '1rem',
      },
      640: {
        perPage: 1,
        gap: '0.5rem',
      }
    }
  };

  // Function to render star ratings
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star 
        key={index}
        size={16}
        fill={index < rating ? "#FFD700" : "none"}
        stroke={index < rating ? "#FFD700" : "#D1D5DB"}
        className="inline"
      />
    ));
  };

  return (
    <div id='Menu'>
        <div className='mt-12 md:py-24 bg-[#EDF7F8] flex flex-col items-center p-4'>
            <h1 className='text-[#FFA300] md:text-5xl text-2xl font-handwriting'>Our Top Menu</h1>
            <p className='my-2 font-bold text-3xl md:text-7xl signika text-[#16B97A]'>Our Special Dishes</p>
            <p className='font-bold text-md alata md:text-5xl'>FOR CHRISTMAS</p>
            <p className='my-4 md:text-xl mb-12 text-center text-sm quicksand my-2 text-gray-500 max-w-4xl'>
                For this Christmas, we have prepared a special menu for you. We have carefully selected the best dishes for you and your family.
            </p>

            {/* Auto-playing Carousel Section with Loop */}
            <div className='w-[95%] mx-auto'>
              <Splide 
                options={splideOptions}
                aria-label="Our Special Christmas Dishes"
              >
                {menuItems.map((item) => (
                  <SplideSlide key={item.id}>
                    {/* Food Card - Exact design from screenshot */}
                    <div 
                      className="h-[409px] md:w-[360px] mx-4 bg-white shadow-gray-200 shadow-2xl"
                      style={{
                        borderTopLeftRadius: '70px',
                        borderBottomRightRadius: '70px'
                      }}
                    >
                      {/* Image */}
                      <img 
                        src={item.image} 
                        alt={item.name}
                        className="h-[250px] md:w-[360px] w-full mx-auto object-cover"
                        style={{
                          borderBottomRightRadius: '70px',
                          borderTopLeftRadius: '70px'
                        }}
                      />
                      
                      {/* Content */}
                      <div className="p-4">
                        {/* Rating Stars */}
                        <div className="flex gap-2 mt-2 pl-4 items-center">
                          {renderStars(item.rating)}
                          <span className="text-gray-600 font-semibold">{item.reviews}</span>
                        </div>
                        
                        {/* Dish Name */}
                        <h1 className="text-2xl font-bold pl-4 signika mt-2">{item.name}</h1>
                        
                        {/* Price */}
                        <p className="font-semibold text-xl alata text-[#FFA300] pl-4 mt-1">
                          {item.price}
                        </p>
                        
                        {/* Description */}
                        <p className="text-gray-500 quicksand pl-4 mt-1">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </SplideSlide>
                ))}
              </Splide>
            </div>
        </div>
    </div>
  )
}

export default Menu